import { render, staticRenderFns } from "./dialog-shopdee.vue?vue&type=template&id=1992ab6e&"
import script from "./dialog-shopdee.vue?vue&type=script&lang=js&"
export * from "./dialog-shopdee.vue?vue&type=script&lang=js&"
import style0 from "./dialog-shopdee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports